import { render, staticRenderFns } from "./BrandTablePage.vue?vue&type=template&id=de5d9a00"
import script from "./BrandTablePage.vue?vue&type=script&lang=js"
export * from "./BrandTablePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports